import { Box } from "@mui/material";

const DarkLightMapImg = () => {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <img
        src="/static/images/darkMap.png"
        alt="map"
        width={576}
        height={370}
        style={{
          width: "100%",
          height: "auto",
        }}
        sizes="100vw"
      />
    </Box>
  );
};

export default DarkLightMapImg;
